import React from "react";

const Input = ({ id, type = "text", placeholder, value, onChange, error }) => {
  return (
    <div className="mb-4 w-3/4 mx-auto">
      <label
        htmlFor={id}
        className="block text-gray-700 text-sm font-bold mb-2"
      >
        {placeholder}
      </label>
      <input
        id={id}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`w-full px-3 py-2 border-2 rounded-lg focus:outline-none ${
          error ? "border-red-500" : "border-primary focus:border-secondary"
        }`}
      />
      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
};

export default Input;
